import React, { Children } from 'react';
import PropTypes from 'prop-types';

const Breadcrumbs = ({ children }) => {
  const wrappedChildren = Children.map(children, child => child && (
    <li className="text-xs">{child}</li>
  ));
  return (
    <div className="">
      <ol className="d-flex align-items-center breadcrumb">
        {wrappedChildren}
      </ol>
    </div>
  );
};

Breadcrumbs.propTypes = {
  children: PropTypes.array.isRequired,
};


export default Breadcrumbs;
